/** @format */

import Carousels from "./../components/Carousels";
import Tooltips from "./../components/Tooltips";

export default class Lazyload {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Lazyload();
		self.attachEvents();
	}

	static watchNewElement(selector) {
		const self = new Lazyload();
		self.watchElement(selector);
	}

	static loadScripts(selector) {
		const self = new Lazyload();

		const elements = document.querySelectorAll(selector);

		if (elements.length > 0) {
			elements.forEach((element) => {
				self.preloadScript(element);
			});
		}
	}

	attachEvents() {
		const self = this;

		self.watchElement("[data-lazy-img]");
		self.watchElement("[data-lazy-svg]");
		self.watchElement("[data-lazy-request]");
		self.watchElement(".js-carousel-lazy");
		self.watchElement(".js-tooltip-trigger");
		self.watchElement("[data-lazy-script]");
		//self.watchElement('[data-lazy-fade-in]', {threshold: 0.1});
		//self.watchElement('[data-lazy-fade-in-stagger]', {threshold: 0.1});

		$(document).on("ajax:update", function () {
			self.watchElement("[data-lazy-img]");
			self.watchElement("[data-lazy-svg]");
			self.watchElement("[data-lazy-request]");
			self.watchElement(".js-carousel-lazy");
			self.watchElement(".js-tooltip-trigger");
			self.watchElement("[data-lazy-script]");
		});

		$(document).on("keydown", function (e) {
			if (
				e.ctrlKey &&
				(e.key == "p" || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80)
			) {
				e.cancelBubble = true;
				e.preventDefault();
				e.stopImmediatePropagation();

				self.printPageLazy();
			}
		});

		window.site.lazyLoad = function (selector) {
			self.watchElement(selector);
		};

		window.site.printPageLazy = function () {
			self.printPageLazy();
		};
	}

	watchElement(selector, customConfig) {
		const self = this;

		let elements = document.querySelectorAll(selector),
			defaultConfig = {
				rootMargin: "50px 0px",
				threshold: 0.01,
			},
			config = Object.assign(defaultConfig, customConfig);

		// Temporarily disable lazy loading site-wide and resolve elements immediately.
		Array.from(elements).forEach(function (element) {
			self.preloadElement(element);
		});

		return;

		// if (!("IntersectionObserver" in window)) {
		// 	var elementsArray = [];
		//
		// 	for (var i = 0; i < elements.length; i++) {
		// 		elementsArray.push(elements[i]);
		// 	}
		//
		// 	elementsArray.forEach(function (element) {
		// 		self.preloadElement(element);
		// 	});
		// } else {
		// 	var observer = new IntersectionObserver(function (entries) {
		// 		entries.forEach(function (entry) {
		// 			if (entry.isIntersecting === true || entry.intersectionRatio > 0) {
		// 				observer.unobserve(entry.target);
		// 				self.preloadElement(entry.target);
		// 			}
		// 		});
		// 	}, config);
		//
		// 	elements.forEach(function (element) {
		// 		if (element.classList.contains("is-lazy-observed")) {
		// 			return;
		// 		}
		//
		// 		element.classList.add("is-lazy-observed");
		// 		observer.observe(element);
		// 	});
		// }
	}

	printPageLazy() {
		const self = this;

		oc.progressBar.show();

		var images = document.querySelectorAll("[data-lazy-img]"),
			imagesArray = [];

		for (var i = 0; i < images.length; i++) {
			imagesArray.push(images[i]);
		}

		imagesArray.forEach(function (image) {
			self.preloadImage(image);
		});

		setTimeout(function () {
			$("body").imagesLoaded({ background: true }, function () {
				oc.progressBar.hide();
				window.print();
			});
		}, 100);
	}

	preloadElement(element) {
		const self = this;

		if (element.hasAttribute("data-lazy-img")) {
			self.preloadImage(element);
		} else if (element.hasAttribute("data-lazy-svg")) {
			self.preloadSvg(element);
		} else if (element.hasAttribute("data-lazy-request")) {
			self.preloadOcRequest(element);
		} else if (element.hasAttribute("data-lazy-fade-in")) {
			self.fadeInElement(element);
		} else if (element.hasAttribute("data-lazy-fade-in-stagger")) {
			self.fadeInStaggerElement(element);
		} else if (element.className.indexOf("js-carousel-lazy") >= 0) {
			self.preloadCarousel(element);
		} else if (element.className.indexOf("js-tooltip-trigger") >= 0) {
			self.preloadTooltip(element);
		} else if (element.hasAttribute("data-lazy-script")) {
			self.preloadScript(element);
		}
	}

	preloadImage(image) {
		var elementName = image.tagName.toLowerCase(),
			imgSrc = image.getAttribute("data-lazy-img");

		if (elementName == "img") {
			image.src = imgSrc;
		} else {
			image.style.backgroundImage = "url(" + imgSrc + ")";
		}
	}

	preloadSvg(svg) {
		var svgFile = svg.getAttribute("data-lazy-svg"),
			url = window.site.themeDir + "/assets/svgs/" + svgFile + ".svg";

		var ajax = new XMLHttpRequest();
		ajax.open("GET", url, true);
		ajax.send();

		ajax.onload = function (e) {
			svg.innerHTML = ajax.responseText;
		};
	}

	preloadOcRequest(element) {
		const self = this;

		var request = element.getAttribute("data-lazy-request"),
			data = element.getAttribute("data-request-data")
				? JSON.parse(element.getAttribute("data-request-data"))
				: {},
			update = JSON.parse(element.getAttribute("data-request-update")),
			successScript = element.getAttribute("data-lazy-success-script");

		oc.ajax(request, {
			data: data,
			update: update,
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				$.each(update, function (partial, el) {
					$('[data-toggle="tooltip"]').tooltip();

					if ($(el + " .js-carousel").length > 0) {
						Carousels.initCarousel($(el + " .js-carousel"));
					}

					if ($(el + " [data-lazy-img]").length > 0) {
						self.watchElement("[data-lazy-img]");
					}

					if ($(el + " [data-lazy-svg]").length > 0) {
						self.watchElement("[data-lazy-svg]");
					}

					if (successScript) {
						eval(successScript);
					}
				});
			},
		});
	}

	fadeInElement(element) {
		const self = this;

		$(element).addClass("is-animated-in");
	}

	fadeInStaggerElement(element) {
		const self = this;

		let $elements = $(element).find("[data-lazy-fade-in-stagger-item]"),
			timeout = 0;

		$elements.each(function () {
			let $element = $(this);

			setTimeout(function () {
				$element.addClass("is-animated-in");
			}, timeout);

			timeout += 250;
		});
	}

	preloadCarousel(element) {
		let $carousel = $(element);

		if (!$carousel.hasClass("slick-initialized")) {
			Carousels.initCarousel($carousel);
		}
	}

	preloadTooltip(tooltip) {
		let $tooltip = $(tooltip);

		// console.log("preload tooltip");

		Tooltips.initTooltip($tooltip);
	}

	preloadScript(element) {
		// Get the script URL and optional inline script code from data attributes
		const scriptSrc = element.getAttribute("data-lazy-script-src");
		const inlineScript = element.getAttribute("data-lazy-script");

		// Load external script if specified
		if (scriptSrc) {
			const script = document.createElement("script");
			script.src = scriptSrc;
			script.onload = () => {
				if (inlineScript) eval(inlineScript);
				// Remove attributes to prevent re-loading
				element.removeAttribute("data-lazy-script-src");
				element.removeAttribute("data-lazy-script");
			};
			document.body.appendChild(script);
		} else if (inlineScript) {
			// Execute inline script directly if present
			eval(inlineScript);
			// Remove attribute to prevent re-executing
			element.removeAttribute("data-lazy-script");
		}
	}
}
